var InternalLogin;
(function (InternalLogin) {
    document.addEventListener('ControllerReady', function () {
        var _a, _b;
        const $internalLogin = document.querySelector('.internal-login');
        if ($internalLogin) {
            const $form = $internalLogin.querySelector('#login-form');
            const $logged = $internalLogin.querySelector('#logged-in');
            const $cardNumber = $form.querySelector('.card-number');
            const $date = $form.querySelector('.date');
            const $submitBtn = $form.querySelector('button');
            const $logOutBtn = $logged.querySelector('button');
            const $errorMsg = $form.querySelector('.error-message');
            const data = retrieveConfig($internalLogin);
            const coopId = (_b = (_a = document.querySelector('#in-place-brand')) === null || _a === void 0 ? void 0 : _a.querySelector(".brand-id")) === null || _b === void 0 ? void 0 : _b.innerText.trim();
            try {
                const logInInfo = JSON.parse(sessionStorage.getItem('loyalty-id'));
                if (data) {
                    enableLogOut(logInInfo.id);
                }
                else
                    throw '';
            }
            catch (_c) {
                initUI();
            }
            function enableLogOut(id) {
                $form.remove();
                const link = $internalLogin.querySelector('.link > a').getAttribute('href');
                if (link) {
                    location.href = link;
                }
                else {
                    $logged.querySelector('.card-number').innerHTML = id;
                    $logged.classList.remove('hidden');
                    $logOutBtn.addEventListener('click', () => {
                        sessionStorage.removeItem('loyalty-id');
                        location.reload();
                    });
                }
            }
            function initUI() {
                [$cardNumber, $date].forEach($el => {
                    $el.addEventListener('change', () => {
                        $cardNumber.value && $date.value
                            ? $submitBtn.removeAttribute('disabled')
                            : $submitBtn.setAttribute('disabled', '');
                    });
                });
                $form.addEventListener('submit', evt => {
                    evt.preventDefault();
                    const cardNumber = $cardNumber.value;
                    const date = $date.value;
                    if (coopId && cardNumber && date) {
                        var url = {
                            coopId: coopId,
                            eanCard: cardNumber,
                            birthdate: getCorrectDateTime(date),
                        };
                        $errorMsg.classList.add('hidden');
                        Fetch('/api/esb/user/verifyLoyaltyInfo?_format=form', {
                            method: 'POST',
                            data: url,
                            token: {
                                enable: true,
                            },
                        }).then((response) => {
                            var _a, _b, _c;
                            if (((_a = response === null || response === void 0 ? void 0 : response.header) === null || _a === void 0 ? void 0 : _a.result) === 'OK' && ((_b = response === null || response === void 0 ? void 0 : response.payload) === null || _b === void 0 ? void 0 : _b.cardStatus) === 'A') {
                                sessionStorage.setItem('loyalty-id', JSON.stringify({
                                    id: cardNumber,
                                    date: new Date().getTime()
                                }));
                                enableLogOut(cardNumber);
                            }
                            else {
                                throw ((_c = response === null || response === void 0 ? void 0 : response.header) === null || _c === void 0 ? void 0 : _c.errorMessage) || 'Si è verificato un errore inaspettato durante il processo di login, riprova tra qualche ora';
                            }
                        }).catch((msg) => {
                            $errorMsg.innerHTML = msg;
                            $errorMsg.classList.remove('hidden');
                            _flog(0, msg, {
                                url: '/api/esb/user/verifyLoyaltyInfo',
                                tesseraSocio: cardNumber,
                                dataNascita: 'hidden for privacy purpose',
                            }, {});
                        });
                    }
                });
            }
            function getCorrectDateTime(date) {
                let data = date.replace(/(\d{4})-(\d{1,2})-(\d{1,2})/, function (match, y, m, d) {
                    return d + '/' + m + '/' + y;
                });
                return data;
            }
            function retrieveConfig($wrapper) {
                let data = {
                    url: '',
                    config: {},
                };
                const $form = $wrapper && $wrapper.querySelector('.ep-config');
                if ($form) {
                    try {
                        const url = $form.querySelector('[name="url"]').value;
                        const config = $form.querySelector('[name="config"]').value;
                        data = {
                            url: url.replace(/\/$/, ''),
                            config: JSON.parse(config),
                        };
                    }
                    catch (e) {
                        console.log('Error during retrieval of configuration for current service. %s', e);
                    }
                }
                return data;
            }
        }
    });
})(InternalLogin || (InternalLogin = {}));
